import { cn } from '@/lib/utils/cn';

interface WordmarkProps {
  className?: string;
}

/** Text wordmark used in place of an image logo. */
export function Wordmark({ className }: WordmarkProps) {
  return (
    <span className={cn('text-xl font-semibold tracking-tight text-foreground', className)}>
      Sequencer
    </span>
  );
}
